export const versionT = "V1.0.0";
export const versionTest = [
  {
    version: "V1.0.0",
    date: "2023-12-28",
    newDetail: [
      "放弃项目，在PMS系统中不能进行任何操作；",
      "任务增加回复功能，可快速指回；",
      "去掉项目编号中的N和C，历史数据不处理；",
      "需求移交，支持换到其他项目下；"
    ],
    fixDetail: [
      "创建子任务按钮，放到任务列表中。同时“创建子任务”，“删除” 按钮用图标展示；",
      "任务列表显示优化，更多空间展示任务描述；",
      "任务有子任之后，也可指派其他人；",
      "项目列表中，“合同类型”修改为“项目类型”；",
      "项目管理页面中，增加商务负责人筛选；",
      "首页点击进入需求、任务，在当前页面打开；",
      "我的流水修改为：只显示我自己的操作流水；"
    ]
  }
];
